'use client';

import { Metroline } from '@mv/web-ui';
import { nodesToMetrolineContentParts } from '@/payload/components/Metroline/utils';
import RichText, { type RichTextContent, type RichTextOptions } from '@/payload/components/RichText/RichText';

type MetrolineRichTextProps = {
	steps?: RichTextContent;
	options?: RichTextOptions;
};

export default function MetrolineRichText({ steps, options }: MetrolineRichTextProps) {
	if (!steps) return null;

	const contentParts = nodesToMetrolineContentParts(steps.root);

	return (
		<Metroline>
			{contentParts.map((content, index) => (
				<Metroline.Item number={index + 1} key={content._key}>
					<RichText content={content} options={options} />
				</Metroline.Item>
			))}
		</Metroline>
	);
}
